var map = {
	"./ATOM.png": 458,
	"./AVAX.png": 459,
	"./BAKE.png": 460,
	"./BDO.png": 461,
	"./BETH.png": 462,
	"./BHC.png": 463,
	"./BIFI.png": 464,
	"./BNB.png": 465,
	"./BTD.png": 466,
	"./BTS.png": 467,
	"./BUNNY.png": 468,
	"./BURGER.png": 469,
	"./CAKE.png": 470,
	"./CTK.png": 471,
	"./DOT.png": 472,
	"./DRUGS.png": 473,
	"./ETH.png": 474,
	"./FTM.png": 475,
	"./HARD.png": 476,
	"./HPS.png": 477,
	"./HT.png": 478,
	"./INCH.png": 479,
	"./INJ.png": 480,
	"./JETS.png": 481,
	"./JULD.png": 482,
	"./KEBAB.png": 483,
	"./LINK.png": 484,
	"./MATIC.png": 485,
	"./MDX.png": 486,
	"./MSC.png": 487,
	"./MSS.png": 488,
	"./NUTS.png": 489,
	"./NYA.png": 490,
	"./NYAC.png": 491,
	"./NYAS.png": 492,
	"./POLYGON.png": 493,
	"./SBDO.png": 494,
	"./SFP.png": 495,
	"./SMART.png": 496,
	"./SOAK.png": 497,
	"./SUSHI.png": 498,
	"./TYPH.png": 499,
	"./UNI.png": 500,
	"./XTZ.png": 501,
	"./XVS.png": 502,
	"./cakeHARD.png": 503,
	"./cakeROOBEE.png": 504,
	"./cakeSTAX.png": 505,
	"./cakeTWT.png": 506,
	"./cakebROOBEE.png": 507,
	"./kite.png": 215
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 457;